import icon from "./img/icon-catalogue.svg"

export default function IconCatalogue() {
  return (
      <img src={icon} alt=""/>
  )
}